import { Component, input, output } from '@angular/core';
import { Source } from '../../../../model/chat.model';

@Component({
  selector: 'source-modal',
  imports: [],
  templateUrl: './block-modal.component.html',
  styleUrl: './block-modal.component.scss'
})
export class SourceModalComponent {
  closePanel = output();
  sources = input<Source[]>();

}
